import { Base } from './Base'

export class Model extends Base {
  toJson () {
    return this.attrs()
  }
}
